import { defineStore } from 'pinia'

export let useAppStore = defineStore('appdata', {
  state: () => ({
    app: null,
    appdata: null
  })
})
